/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

legend {
  border: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: table;
  max-width: 100%;
  padding: 0;
  color: inherit;
  white-space: normal;
  margin-bottom: 8px;
}

.#{$prefix}checkbox-group-title {
  @include eon-typography(copy);
  color: v(labelColor);
  margin-bottom: 24px !important;

  .#{$prefix}title-icon {
    display: flex; 
    column-gap: 8px;

    .group-info-icon {
      margin-top: calc((var(--lineHeight) - 20px)/2);
    }
  }

  &.#{$prefix}h3 {
    @include eon-typography(h3);
  }

  &.#{$prefix}h4 {
    @include eon-typography(h4);
  }

  &.#{$prefix}h5 {
    @include eon-typography(h5);
  }

  &.#{$prefix}abstract {
    @include eon-typography(abstract);
  }

  &.#{$prefix}copy {
    @include eon-typography(copy);
  }

  &.#{$prefix}copy-small {
    @include eon-typography(copy-small);
  }
}

.#{$prefix}error {
  fill: v(errorColor);
  color: v(errorColor);
}

::slotted(eon-ui-checkbox) {
  display: flex;
}

.#{$prefix}checkbox-group-wrapper {
  display: grid;
  row-gap: 24px;
  flex-wrap: wrap;

  &.#{$prefix}horizontal-align {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 24px;
    row-gap: 24px;

    ::slotted(eon-ui-checkbox) {
      display: inline-block;
      width: auto;
    }
  }
}
